import { render, staticRenderFns } from "./specialMaterialDetail.vue?vue&type=template&id=3ddd9bc6&scoped=true"
import script from "./specialMaterialDetail.vue?vue&type=script&lang=js"
export * from "./specialMaterialDetail.vue?vue&type=script&lang=js"
import style0 from "./specialMaterialDetail.vue?vue&type=style&index=0&id=3ddd9bc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddd9bc6",
  null
  
)

export default component.exports